(() => {
  // This indicator represents the contact menu's opening hours, not Intercom presence.
  const attribute = 'data-chat-office-open';
  const weekdays = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  function isOpen(schedule, now) {
    if (!schedule) return false;
    if (schedule.contactHubOfficeStart === '' || schedule.contactHubOfficeEnd === '') return false;
    const days = String(schedule.contactHubOfficeDays || '').split(',').map(Number);
    const start = Number(schedule.contactHubOfficeStart);
    const end = Number(schedule.contactHubOfficeEnd);
    if (!Number.isFinite(start) || !Number.isFinite(end)
      || start < 0 || start >= 24 || end < 0 || end > 24) return false;

    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
        timeZone: schedule.contactHubTimeZone || 'Europe/Paris',
        weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23',
      }).formatToParts(now).map(({ type, value }) => [type, value]));
      const day = weekdays[parts.weekday];
      const minutes = Number(parts.hour) * 60 + Number(parts.minute);

      if (start === end) return days.includes(day);
      if (start < end) return days.includes(day) && minutes >= start * 60 && minutes < end * 60;
      const previousDay = day === 1 ? 7 : day - 1;
      return (days.includes(day) && minutes >= start * 60)
        || (days.includes(previousDay) && minutes < end * 60);
    } catch {
      return false;
    }
  }

  function refresh() {
    const source = document.querySelector('[data-contact-hub-office-days][data-contact-hub-office-start][data-contact-hub-office-end]');
    document.documentElement.toggleAttribute(attribute, isOpen(source?.dataset, new Date()));
  }

  function start() {
    refresh();
    window.setInterval(refresh, 30000);
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
